// bit gross as the styles depend heavily on the other "title" styles (mainly the mb-3)
export const TitleLoader = (): React.ReactElement<any, any> | null => {
    return (
        <div className="text-input__loading">
            <div className="text-input__loading--line big rounded"></div>
        </div>
    );
};
